export default {
  HAS_TOKEN: (state) => {
    return state.token !== null;
  },

  user: (state) => {
    return state.user;
  },
};
